import { render } from "./EmailCategoryManager.vue?vue&type=template&id=35b6c45d"
import script from "./EmailCategoryManager.vue?vue&type=script&lang=js"
export * from "./EmailCategoryManager.vue?vue&type=script&lang=js"

import "./EmailCategoryManager.vue?vue&type=style&index=0&id=35b6c45d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__